import { useState, useEffect } from "react";
import { CiHeart } from "react-icons/ci";
import { AiFillHeart } from "react-icons/ai";
import { useNavigate } from "react-router";
import DefaultImage from './Images/DefaultImage.png';
import AdsService from "../../../../services/Ads";

export default function AdsCart({ image, title, description, price, dealType, postedHoursAgo, index, id, isSaved ,hasBorder=true}) {

  // const [liked, setLiked] = useState(false);
  const [animate, setAnimate] = useState(false);
  const navigate = useNavigate();
  const [isLiked, setIsLiked] = useState(isSaved);
  const [isLoading, setIsLoading] = useState(false);


  const handleLike = async (e) => {
    try {
      setIsLoading(true);
      e.stopPropagation();
      const body = {
        rentalSaleId: id
      }
      if (isLiked) {
        await AdsService.disLikeAd(body);
      } else {
        await AdsService.likeAd(body);
      }
      setIsLiked(prev => !prev);
      console.log("Ad liked status:", !isLiked);
    } catch (err) {
      console.error("Error liking ad:", err);
    }
    finally {
      setIsLoading(false);
    }
  };

  return (
    <div onClick={() => navigate(`/ads/${id}`)}
      className={`
               w-full h-full     flex flex-col  max-sm:justify-between   max-sm:flex-row p-2 md:p-3 ${hasBorder && 'border-[1px] border-gray-200  rounded-lg shadow-md'} 
            `}
    >
      <div className="relative w-full sm:w-full max-sm:w-28 max-sm:h-[150px]  flex-shrink-0 overflow-hidden sm:h-[250px] max-sm:order-2">
        <img
          src={isLoading ? DefaultImage : image ? `https://barsaraa.maksiran.ir${image}` : DefaultImage}
          alt={title}
          className={`
          w-full h-full object-cover
          sm:rounded-lg
          max-sm:rounded-none max-sm:rounded-r-lg
          ${isLoading ? "animate-pulse" : ""}
        `}
        />


        <div
          className="absolute bottom-2 left-2 flex items-center gap-2 bg-black bg-opacity-50 rounded-full px-2 py-1 cursor-pointer"
          onClick={handleLike}
        >
          <span className="text-xs text-white">{postedHoursAgo}</span>
          <span className={`flex items-center justify-center transition-transform duration-300 ${animate ? "scale-125 animate-pulse" : ""}`}>
            {isLiked ? (
              <AiFillHeart className="w-5 h-5 text-red-600" />
            ) : (
              <CiHeart className="w-5 h-5 text-white" />
            )}
          </span>
        </div>
      </div>

      <div className="p-3 flex flex-col gap-2 max-sm:order-1 max-sm:w-2/3 ">
        <h2 className="text-base font-semibold text-black line-clamp-1">{title}</h2>
        <p className="text-sm text-gray-500  sm:h-8 whitespace-wrap  truncate md:w-full max-sm:w-2/3 overflow-hidden">{description}</p>
        <div className="flex flex-col sm:flex-row md:flex-col lg:flex-row gap-2 items-start sm:items-center justify-between mt-auto pt-2 ">
          <span className="text-sm rounded-full whitespace-nowrap truncate sm:w-full lg:w-auto sm:text-center bg-[#a7c9f1] text-gray-700 px-2 py-0.5">
            {price === "تماس بگیرید" ? "تماس بگیرید" : `${price} تومان`}
          </span>
          <span className="text-sm font-medium whitespace-nowrap  sm:w-full lg:w-auto sm:text-center truncate text-gray-500">
            نوع معامله: {dealType === "rent" ? "اجاره" : "فروش"}
          </span>
        </div>
      </div>
    </div>
  );
}